import React from "react";
import { Link } from "react-router-dom";
import { usePageContent } from "../../hooks/usePageContent";
import "./index.module.css";

const RestyleLandingPage = () => {
  const { find } = usePageContent("restyle-landing");
  const c = find("restyleLanding") || {};

  const ledeHtml = c.ledeHtml || "";
  const productPreviewItems = c.productPreviewItems || [];
  const hasProductPreview = c.productPreviewFeaturedImageSrc || productPreviewItems.length > 0;

  return (
    <div id="content">
      <div className="row">
        <div className="page-header">
          <div className="page-header__content">
            <h1 className="page-header__title">
              {c.pageTitle || "Restyle your number plates"}
            </h1>
          </div>
        </div>
        <div className="restyle-ctas">
          <div className="restyle-ctas__inner">
            <p className="restyle-ctas__lede">
              {c.ctaLede || "Keep your existing combination; change the design of your plate!"}
            </p>
            <div className="restyle-ctas__buttons">
              <Link
                to="/restyle/check-combination"
                className="button button--full-width"
              >
                {c.ctaRestyleText || "Restyle my plate"}
              </Link>
              <Link
                to="/create/check-combination"
                className="button button--full-width button--secondary button--secondary-grass"
              >
                {c.ctaCreateText || "Create new plate"}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="component restyle-landing-page">
          <div className="restyle-landing">
            <h2 className="restyle-landing__title">
              {c.sectionTitle || "Is your ride ready for a new look?"}
            </h2>
            <div
              className="restyle-landing__lede rich-text"
              dangerouslySetInnerHTML={{ __html: ledeHtml }}
            />
            <div className="restyle-landing__actions">
              <Link
                to="/restyle/check-combination"
                className="button"
              >
                <span className="button--text">
                  {c.actionText || "Restyle your plates now"}
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {hasProductPreview && (
        <div className="row">
          <div className="product-preview">
            {c.productPreviewFeaturedImageSrc && (
              <>
                <div className="product-preview__item">
                  <div className="product-preview__image-container">
                    <img
                      className="product-preview__image"
                      src={c.productPreviewFeaturedImageSrc}
                      alt={c.productPreviewFeaturedImageAlt || ""}
                      width="334"
                      height="auto"
                    />
                  </div>
                  <div className="product-preview__colour">
                    <span className="visuallyhidden"></span>
                  </div>
                </div>
                <br />
              </>
            )}
            {c.productPreviewIntro && (
              <div><p><strong>{c.productPreviewIntro}</strong></p><br/></div>
            )}
            {productPreviewItems.length > 0 && (
              <ul className="product-preview__list">
                {productPreviewItems.map((item, i) => (
                  <li key={i} className="product-preview__item">
                    <div className="product-preview__image-container">
                      <img
                        className="product-preview__image"
                        src={item.imageSrc}
                        alt={item.imageAlt || ""}
                      />
                    </div>
                    <div className="product-preview__colour">
                      <span className="visuallyhidden"></span>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default RestyleLandingPage;
